import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {baseUrl} from "../Univ";

function SupplierQuotationPrint() {

    const {id} = useParams();

    const [quotation, setQuotation] = useState({});
    const [items, setItems] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        try {

            const quotationRes = await axios.get(
                baseUrl + "update-supplier-quotation/" + id + "/"
            );

            setQuotation(quotationRes.data);

            const itemRes = await axios.get(
                baseUrl + "supplier-quotation-item/" + id + "/"
            );

            setItems(itemRes.data);

        } catch (err) {
            console.log(err);
        }

    };

    const handlePrint = () => {

        const printContents =
            document.getElementById("print-area").innerHTML;

        const originalContents =
            document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        setTimeout(() => {
            window.location.reload();
        }, 1000);

        document.body.innerHTML = originalContents;

    };

    return (

        <section className="container mt-4">

            <div id="print-area">

                <table
                    width="100%"
                    style={{
                        borderBottom: "2px solid black",
                        marginBottom: "20px"
                    }}
                >

                    <tbody>

                    <tr>

                        <td>

                            <h2>EAgri ERP</h2>

                            <h5>Supplier Quotation</h5>

                            <div>
                                Procurement Management System
                            </div>

                        </td>

                        <td align="right">

                            <h4>
                                Quotation No :
                                {" "}
                                {quotation.quotation_no}
                            </h4>

                            <div>
                                Date :
                                {" "}
                                {quotation.quotation_date}
                            </div>

                            <div>
                                Valid Till :
                                {" "}
                                {quotation.validity_date}
                            </div>

                            <div>
                                Status :
                                {" "}
                                {quotation.status}
                            </div>

                        </td>

                    </tr>

                    </tbody>

                </table>

                <table
                    width="100%"
                    style={{
                        marginBottom: "20px"
                    }}
                >

                    <tbody>

                    <tr>

                        <td width="50%">

                            <h5>Supplier Details</h5>

                            <b>
                                {quotation.supplier?.name}
                            </b>

                            <br/>

                            {quotation.supplier?.mobile}

                            <br/>

                            {quotation.supplier?.email}

                            <br/>

                            {quotation.supplier?.address}

                        </td>

                        <td width="50%">

                            <h5>RFQ Details</h5>

                            <b>
                                RFQ :
                                {" "}
                                {quotation.rfq?.rfq_no}
                            </b>

                            <br/>

                            Delivery Days :
                            {" "}
                            {quotation.delivery_days}

                            <br/>

                            Payment Terms :
                            {" "}
                            {quotation.payment_terms}

                        </td>

                    </tr>

                    </tbody>

                </table>
                        <div className="table-responsive">

                    <table
                        width="100%"
                        border="1"
                        cellPadding="6"
                        style={{
                            borderCollapse: "collapse",
                            marginTop: "20px"
                        }}
                    >

                        <thead
                            style={{
                                background: "#198754",
                                color: "#fff"
                            }}
                        >

                        <tr>

                            <th>S.No</th>

                            <th>Item</th>

                            <th>Requested Qty</th>

                            <th>Quoted Qty</th>

                            <th>Rate</th>

                            <th>Discount %</th>

                            <th>GST %</th>

                            <th>Brand</th>

                            <th>Amount</th>

                        </tr>

                        </thead>

                        <tbody>

                        {items.map((row, index) => {

                            const qty = parseFloat(row.quantity || 0);

                            const rate = parseFloat(row.rate || 0);

                            const discount = parseFloat(row.discount_percent || 0);

                            const gst = parseFloat(row.gst_percent || 0);

                            const basic = qty * rate;

                            const discountAmount = (basic * discount) / 100;

                            const taxable = basic - discountAmount;

                            const gstAmount = (taxable * gst) / 100;

                            const total = taxable + gstAmount;

                            return (

                                <tr key={row.id}>

                                    <td align="center">

                                        {index + 1}

                                    </td>

                                    <td>

                                        {row.purchase_request_item?.item?.item_name}

                                    </td>

                                    <td align="right">

                                        {row.purchase_request_item?.quantity}

                                    </td>

                                    <td align="right">

                                        {row.quantity}

                                    </td>

                                    <td align="right">

                                        ₹ {rate.toFixed(2)}

                                    </td>

                                    <td align="right">

                                        {discount} %

                                    </td>

                                    <td align="right">

                                        {gst} %

                                    </td>

                                    <td>

                                        {row.brand}

                                    </td>

                                    <td align="right">

                                        ₹ {total.toFixed(2)}

                                    </td>

                                </tr>

                            );

                        })}

                        </tbody>

                        <tfoot>

                        <tr>

                            <th
                                colSpan="8"
                                style={{
                                    textAlign: "right"
                                }}
                            >

                                Grand Total

                            </th>

                            <th
                                style={{
                                    textAlign: "right"
                                }}
                            >

                                ₹ {items.reduce((sum, row) => {

                                    const qty = parseFloat(row.quantity || 0);

                                    const rate = parseFloat(row.rate || 0);

                                    const dis = parseFloat(row.discount_percent || 0);

                                    const gst = parseFloat(row.gst_percent || 0);

                                    const basic = qty * rate;

                                    const discountAmount = (basic * dis) / 100;

                                    const taxable = basic - discountAmount;

                                    const gstAmount = (taxable * gst) / 100;

                                    return sum + taxable + gstAmount;

                                }, 0).toFixed(2)}

                            </th>

                        </tr>

                        </tfoot>

                    </table>

                </div>

                <div
                    style={{
                        marginTop: "30px"
                    }}
                >

                    <h5>

                        Remarks

                    </h5>

                    <p>

                        {quotation.remarks || "-"}

                    </p>

                </div>
                        <br/><br/>

                <table width="100%">

                    <tbody>

                    <tr>

                        <td align="left">

                            __________________________

                            <br/>

                            Supplier Signature

                        </td>

                        <td align="right">

                            __________________________

                            <br/>

                            Authorized Signatory

                        </td>

                    </tr>

                    </tbody>

                </table>

            </div>

            <div
                className="text-center mt-4"
                style={{marginBottom: "50px"}}
            >

                <button
                    className="btn btn-primary"
                    onClick={handlePrint}
                >

                    Print Supplier Quotation

                </button>

            </div>

        </section>

    );

}

export default SupplierQuotationPrint;